import { FinderStageId } from 'entities-next/stages'

export type PairingStageFilter = FinderStageId | 'no-stage'

export const pairingStageFilters = [...Object.values(FinderStageId), 'no-stage']
